import React, { useEffect, useState } from 'react';
// import { Table } from '@veneer/table';
import {
  Pagination,
  Button,
  Search,
  Select,
  Table,
  IconDownload,
  IconTrash,
} from '@veneer/core';
import ConnectAPI from '../../../services/api';
import Swal from 'sweetalert2';
import moment from 'moment';
import { numberFormatComma } from './../../../common/js/utils/numberFormat';
import XLSX from 'xlsx';
import { Trans } from 'react-i18next';
import { translate } from 'react-i18next';

const CompensationPrices = (props) => {
  const configPrices = [
    // {
    //   id: 'idCustomer',
    //   label: 'Id Customer',
    // },
    {
      id: 'customerName',
      label: <Trans i18nKey='channel' />,
      filter: (
        <Search
          name="customer-search"
          onChange={(value) =>
            handleSingleFilter({
              id: 'customerName',
              filterValue: value,
            })
          }
        />
      ),
    },
    {
      id: 'endUserName',
        label: <Trans i18nKey='specialcondition.enduser' />,
      filter: (
        <Search
          name="enduserb-search"
          onChange={(value) =>
            handleSingleFilter({
              id: 'endUserName',
              filterValue: value,
            })
          }
        />
      ),
    },
    {
      id: 'idPress',
      label: <Trans i18nKey='press id' />,
      filter: (
        <Search
          name="idPress-search"
          onChange={(value) =>
            handleSingleFilter({
              id: 'idPress',
              filterValue: value,
            })
          }
        />
      ),
    },
    { id: 'serviceArea', label: <Trans i18nKey='region' /> },
    { id: 'series', label: <Trans i18nKey='series' /> },
    {
      id: 'type',
      label: <Trans i18nKey='type' />,
    },
    {
      id: 'blackCommitedPrice',
      label: <Trans i18nKey='prices.blackcommprice' />,
    },
    {
      id: 'otherCommitedPrice',
      label: <Trans i18nKey='prices.othercommprice' />,
    },
    {
      id: 'whiteCommitedPrice',
      label: <Trans i18nKey='prices.whitecommprice' />,
    },
    {
      id: 'blackCommitedPriceA3',
      label: <Trans i18nKey='prices.blackcommpricea3' />,
    },
    {
      id: 'otherComitedPriceA3',
      label: <Trans i18nKey='prices.othercommpricea3' />,
    },
    {
      id: 'whiteCommitedPriceA3',
      label: <Trans i18nKey='prices.whitecommpricea3' />,
    },
    {
      id: 'globalTierFormatted',
      label: <Trans i18nKey='prices.globaltier' />,
    },
    {
      id: 'startDateFormatted',
      label: <Trans i18nKey='specialcondition.startdate' />,
    },
    {
      id: 'expireDateFormatted',
        label: <Trans i18nKey='expiredate' />,
    },
    {
      id: 'statusFormatted',
      label: <Trans i18nKey='Status' />,
    },
  ];
  const connectApi = new ConnectAPI();
  //const [preferences, setPreferences] = useState(specialPreferences);
  //const [showClearAllFilters, setShowClearAllFilters] = useState(false);

  const [config, setConfig] = useState(configPrices);
  const [order, setOrder] = useState(config.map((c) => c.id));
  const [orderBy, setOrderBy] = useState('idCustomer');
  const [orderType, setOrderType] = useState('descending');
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingExport, setLoadingExport] = useState(false);
  const pageSize = 50;
  const [dateSelected, setDateSelected] = useState();
  const [datesView, setDatesView] = useState([]);
  const [customerName, setCustomerName] = useState('');
  const [endUserName, setEndUserName] = useState('');
  const [pressId, setPressId] = useState('');

  const exportData = () => {
    setLoadingExport(true);
    setTimeout(() => {
      let excelData = tableData;
      // filteredColumns.forEach((filter) => {
      //   excelData = excelData.filter((row) =>
      //     row[filter.column]
      //       .toString()
      //       .toLowerCase()
      //       .includes(filter.filterValue.toLowerCase())
      //   );
      // });
      //const data = this.state.endUsers;
      //console.log(excelData);

      //let dataBody = [];
      const dataXlsx = excelData; //.map((item) => {
      //     return {
      //       idSharepoint: item.idSharepoint,
      //       channel: item.customer,
      //       endUser: item.endUser,
      //       pressId: item.idPress,
      //       startDate: item.startDate,
      //       endDate: item.endDate,
      //       discountType: item.specialConditionType,
      //       level: item.percentage,
      //       minimumImp: item.minimumImp,
      //       cpp: item.cpp,
      //       comments: item.comments,
      //       status: item.status,
      //     };
      //   });
      // dataXlsx.push({
      //   //month: item.month,
      //   //channel: item.channel,
      //   //customer: item.customer,
      //   //region: item.region,
      //   // tpi: 'Total',
      //   // compensationClient: 0,
      //   // compensationChannel: 0,
      // });
      const ws = XLSX.utils.json_to_sheet(dataXlsx);
      const wb = XLSX.utils.book_new();

      const date = moment(new Date()).format('YYYYMMDDHHmm');

      const filename = 'prices -' + date + '.xlsx';
      const ws_name = 'prices';

      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(wb, filename);

      setLoadingExport(false);
    }, 750);
  };

  useEffect(() => {
    //validate location
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let validate=false;
    currentUser.urls.forEach(ur=>{
      if (ur==window.location.pathname){
        validate=true;
      }
    });
    if (validate==false){
      const { history } = props;
        history.push({
          pathname: '/' 
        });
    }
    //end validate
    const fetchData = () => {
      connectApi

        .get('api/Channels/reports/Dates/', '', datesLoad)
        .catch((error) => {
          Swal.fire(
            'Error ' + error.response.status,
            error.response.data,
            'error'
          );
        });
    };

    const datesLoad = (status, data) => {
      const items = data.map((item) => {
        return {
          value: moment(item.date).format('YYYY-MM-DDTHH:mm:ss'),
          label:
            moment(item.date).format('MMM') +
            ' ' +
            moment(item.date).format('YYYY'),
        };
      });

      const date = items[0] === undefined ? null : items[0].value;
      setDateSelected(date);
      setDatesView(items);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      //dataResponseLoad('400', DATALOCAL);
      connectApi
        .get(
          'api/Channels/CompensationPrices',
          {
            params: {
              date: dateSelected,
            },
          },
          dataResponseLoad
        )
        .catch((error) => {
          setIsLoading(false);
          Swal.fire(
            'Error ' + error?.response?.status,
            error?.response?.data,
            'error'
          );
        });
    };

    const dataResponseLoad = (status, data) => {
      data.map((item, key) => {
        item.startDateFormatted = moment(item.startDate).format('DD/MMM/YYYY');
        item.expireDateFormatted = moment(item.expireDate).format(
          'DD/MMM/YYYY'
        );
        item.globalTierFormatted = item.globalTier.toString();
        item.statusFormatted = item.status.toString();
      });

      //setDataResponse(data === undefined ? [] : data);
      setTableData(data === undefined ? [] : data);
      //console.log(dataResponse);
      setIsLoading(false);
    };

    if (dateSelected != undefined) {
      fetchData();
    }
  }, [dateSelected]);

  const handlePageChange = (page) => setCurrentPage(page);

  const handleOnColumnReorder = (newOrder) => {
    setOrder(newOrder);
  };

  const filteredData = filterSort(
    tableData,
    { customerName, endUserName, idPress: pressId },
    orderBy,
    orderType
  );

  function filterSort(array, filters, orderBy, orderType) {
    let arrayFiltered = array;
    // filter
    Object.keys(filters).forEach((value) => {
      const filterValue = filters[value];
      const filter =
        typeof filterValue === 'object' ? filterValue[0] : filterValue;
      if (filter) {
        arrayFiltered = arrayFiltered.filter((a) => {
          const aUpper = a[value] && a[value].toString().toUpperCase();
          const filterUpper = filter && filter.toString().toUpperCase();

          return aUpper.indexOf(filterUpper) > -1;
        });
      }
    });

    // sort
    return arrayFiltered.sort((a, b) => {
      const value =
        orderType === 'descending'
          ? descendingComparator(a, b, orderBy)
          : -descendingComparator(a, b, orderBy);

      return value;
    });
  }

  function descendingComparator(a, b, orderBy) {
    let aSort =
      typeof a[orderBy] === 'object'
        ? typeof a[orderBy] === typeof (<a />)
          ? a[orderBy].props.href.toString().toUpperCase()
          : a[orderBy].props.label.toString().toUpperCase()
        : a[orderBy].toString().toUpperCase();
    //const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
    let bSort =
      typeof b[orderBy] === 'object'
        ? typeof b[orderBy] === typeof (<a />)
          ? b[orderBy].props.href.toString().toUpperCase()
          : b[orderBy].props.label.toString().toUpperCase()
        : b[orderBy].toString().toUpperCase();
    //const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();

    if (orderBy.includes('Formatted')) {
      const orderByFormatted = orderBy.replace('Formatted', '');
      aSort = a[orderByFormatted];
      bSort = b[orderByFormatted];
    }

    if (bSort < aSort) {
      return -1;
    }
    if (bSort > aSort) {
      return 1;
    }
    return 0;
  }

  let pagedData = filteredData.slice(
    (currentPage - 1) * pageSize,
    (currentPage - 1) * pageSize + pageSize
  );
  useEffect(() => {
    // console.log(customerName);
    pagedData = filteredData.slice(
      (currentPage - 1) * pageSize,
      (currentPage - 1) * pageSize + pageSize
    );
  }, [customerName, endUserName, pressId]);
  //}, []);

  const handleSingleFilter = ({ id, filterValue, table }) => {
    switch (id) {
      case 'customerName':
        setCustomerName(filterValue);
        break;
      case 'endUserName':
        setEndUserName(filterValue);
      case 'idPress':
        setPressId(filterValue);
        break;
      // case 'endUserNameCompensation':
      //   setEndUserNameCompensation(filterValue);
      //   break;
      // case 'serviceAreaCompensation':
      //   setServiceAreaCompensation(filterValue);
      //   break;
      default:
        break;
    }
  };

  const handleSort = (_, { id, type }) => {
    setOrderBy(id);
    setOrderType(type);
  };
  const RenderDateList = () => {
    const handleChange = (name) => (event) => {
      setDateSelected(event.value);
    };

    return (
      <div
        style={{
          width: '230px',
          padding: '0.5% 2% ',
        }}
      >
        <Select
          name="dates"
          onChange={handleChange()}
          //onClear={this.handleDefaultClear}
          options={datesView}
          placeholder="Dates"
          value={[dateSelected]}
        />
      </div>
    );
  };
  return (
    <div>
      <br />
      <div className="row" style={{ textAlign: 'left', padding: '0.5%' }}>
        {RenderDateList()}
      </div>

      <div>
        <br />
        <div
          style={{
            backgroundColor: '#f2f2f2',
            padding: '0.5%',
            // maxWidth: '760px',
          }}
        >
          {/* <div className="row" style={{ textAlign: 'left', padding: '0.5%' }}>

          </div> */}
          <Table
            showFilters
            columnReorder
            columns={config}
            data={pagedData}
            onColumnReorder={handleOnColumnReorder}
            onSort={handleSort}
            loading={isLoading}
            preferences={{
              defaultOrder: config.map((c) => c.id),
              order,
              sortBy: {
                id: orderBy,
                type: orderType,
              },
            }}
            pagination={{
              currentPage,
              onPageChange: handlePageChange,
              pageSize,
              totalItems: filteredData.length,
            }}
          ></Table>
          <div style={{ textAlign: 'left' }}>
            <Button
              leadingIcon={<IconDownload />}
              onClick={() => {
                exportData();
              }}
              disabled={tableData === 0}
              loading={loadingExport}
              title="Download Data"
            >
              <Trans i18nKey='download'/>
            </Button>
          </div>
        </div>
      </div>
      <br />
    </div>
  );
};

export default CompensationPrices;
